import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import App from './App';
import PageLoader from './components/PageLoader';
import RequestApi from './RequestApi';
import ObservableService from '@Services/ObservableService';
import {initRequestInterceptors} from '@Services/RequestService/RequestService';
import {useAuth} from '@Services/AuthService/useAuth';
import { setNavigator } from '@Services/navigation';

import '../sass/app.scss'

const IndexApp = () => {
	const { logout } = useAuth();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		setNavigator(navigate);
	}, [navigate]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	useEffect(() => {
		RequestApi.init();
		initRequestInterceptors(logout);
		ObservableService.init();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<PageLoader />
			<App />
		</>
	)
};

export default IndexApp;